import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from '@services/navigation-service';
import { DialogsService } from '@services/dialogs-service';
import { CuentasService } from '@services/cuentas-service';
import { SpinnerService } from '@services/spinner-service';
import { SignalrService } from '../../../signalr/signalR.service';
import {
 NEGOCIO_TYPE_INTENCION,
 CONFIRMACION_VALUES,
 NEGOCIO_TYPE_DISPO,
 NEGOCIO_TYPE_FORWARD,
 PRODUCTO_SOJA,
 PRODUCTO_MAIZ,
 PRODUCTO_SORGO,
 PRODUCTO_TRIGO,
 PRODUCTO_GIRASOL,
 ENTREGA_VALUES,
 NegociosService,
 getFuenteName
} from '@services/negocios-service';
import { ENTITY_TYPE_NEGOCIO } from '@common/activity-list';
import { PATH_NEGOCIOS, PATH_COLABORADOR_DETAIL, PATH_CUENTA_DETAIL } from '../../../navigation/navigation.module';
import { ColaboradoresService } from '@services/colaboradores-service';
import { HistoryService, HISTORY_LIST_ENTITY } from '@services/history-service';
import * as moment from 'moment';
import { PermisosService, PERM_ACCIONES_ID, NEG_ACTIONS } from '@services/permisos-service';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-negocio-detail',
  templateUrl: './negocio-detail.component.html',
  styleUrls: ['./negocio-detail.component.scss']
})
export class NegocioDetailComponent implements OnInit, OnDestroy {

  public negocio: any = {};
  id: number;

  cuenta: any = {};

  isBefore20: boolean;
  isSojaDispo: boolean;
  showRejectSPButton = false;

  phoneNumbers = [];

  NEGOCIO_TYPE_INTENCION = NEGOCIO_TYPE_INTENCION;
  CONFIRMACION_VALUES = CONFIRMACION_VALUES;
  ENTITY_TYPE_NEGOCIO = ENTITY_TYPE_NEGOCIO;
  NEGOCIO_TYPE_DISPO = NEGOCIO_TYPE_DISPO;
  NEGOCIO_TYPE_FORWARD = NEGOCIO_TYPE_FORWARD;

  actividad = [];
  actividadPage: number = 0;
  keepRetrieving: boolean = true;
  workingFlag: boolean = false;
  dataValid: boolean = true;

  isNegocioCancelado: boolean = false;

  HISTORY_LIST_ENTITY = HISTORY_LIST_ENTITY;
  historyList: any = [];
  historyListAviso: any = [];
  historyLoading = false;

  activitySelected = 'Actividad';
  activityOptions = ['Actividad', 'Cambios de Negocio'];

  @ViewChild('activitySelector') activitySelector;

  editarAllowed = false;
  anularAllowed = false;
  duplicarAllowed = false;
  cambiarTipoAllowed = false;
  autoNoAutoAllowed = false;
  autoNoAutoOlvidadoAllowed = false;
  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  autorizarLabel = '';
  noAutorizarLabel = '';

  onDestroySubject = new Subject();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private detector: ChangeDetectorRef,
              private navService: NavigationService,
              private spinnerService: SpinnerService,
              private dialogsService: DialogsService,
              private negociosService: NegociosService,
              private cuentasService: CuentasService,
              private signalRService: SignalrService,
              private colaboradorService: ColaboradoresService,
              private historyService: HistoryService,
              private permisosService: PermisosService) {
  }

  ngOnInit() {
    this.isBefore20 = null;
    this.negociosService.IsBefore16().take(1).subscribe(x => this.isBefore20 = x.ResponseData)

    Observable.interval(15000)
      .takeUntil(this.onDestroySubject)
      .switchMap(() => this.negociosService.IsBefore16())
      .subscribe(res => {
        this.isBefore20 = res.ResponseData;
      });

    this.route.params.take(1).subscribe(() => {
      this.id = this.route.snapshot.params['id'];
      this.loadData();
    });

    this.signalRService.newEditedNegocioMessage
      .takeUntil(this.onDestroySubject)
      .subscribe(edited => {
        if (edited) {
          this.loadData();
        }
        if (!this.detector['destroyed']) {
          this.detector.detectChanges();
        }
      });
    // Nos suscribimos a este evento también. Aunque no deberíamos. Pero la API a veces envía el evento como negocio nuevo y a veces como
    // negocio editado. Simplemente no olvidemos chequear en newNegocio que el negocio recibido es el que nos interesa
    this.signalRService.newNegocioMessage
      .takeUntil(this.onDestroySubject)
      .subscribe(negocio => {
        if (negocio && Number(negocio.Id) === Number(this.id)) {
          this.loadData();
        }
        if (!this.detector['destroyed']) {
          this.detector.detectChanges();
        }
      });
    }

  navigateBack() {
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_NEGOCIOS);
    }
  }

  loadData() {
    this.spinnerService.setShowFlag(true);
    this.negociosService.getNegocio(this.id).take(1).subscribe(res => {
      this.negocio = res.ResponseData;
      if (!this.negocio) {
        this.spinnerService.setShowFlag(false);
        this.negocio = {};
        this.dataValid = false;
        return;
      }

      // setear info para mostrar el comentario de un negocio anulado
      if (this.negocio.Confirmacion.Estado === 'Anulada') {
        if (!this.negocio.Confirmacion.Comentario) {
          this.negocio.Confirmacion.Comentario = '-';
        }
        this.negocio.Confirmacion.ComentarioHTML = this.negocio.Confirmacion.Comentario.replace(new RegExp('\n', 'g'), '<br />');
        this.isNegocioCancelado = true;
      }

      // El back hace la conversion a hora local, por lo que hacemos la conversion a fecha SIN localizarla
      if (this.negocio.NegocioAvisos && this.negocio.NegocioAvisos.length) {
        this.negocio.NegocioAvisos.forEach(x => {
          x.FechaParsed = moment(x.Fecha * 1000).utc(false).format('DD/MM/YYYY').toString();
        });
      }
      this.negociosService.setCurrentNegocio(this.id).take(1).subscribe();
      this.isSojaDispo = ((this.negocio.Producto && this.negocio.Producto.Producto === PRODUCTO_SOJA) &&
                          (this.negocio.Entrega && (this.negocio.Entrega.Entrega === ENTREGA_VALUES.ENTREGADO
                            || this.negocio.Entrega.Entrega === ENTREGA_VALUES.A_ENTREGAR))
                         ) ||
                         (
                           this.negocio.Entrega && this.negocio.Entrega.Entrega === ENTREGA_VALUES.ENTREGADO &&
                           (this.negocio.Producto && (this.negocio.Producto.Producto === PRODUCTO_MAIZ ||
                             this.negocio.Producto.Producto === PRODUCTO_SORGO ||
                             this.negocio.Producto.Producto === PRODUCTO_TRIGO ||
                             this.negocio.Producto.Producto === PRODUCTO_GIRASOL))
                         );

      if (this.negocio.Confirmacion) {
        this.negocio.Confirmacion.showHours =
          (this.negocio.Confirmacion.Estado === CONFIRMACION_VALUES.MATCHEADA
            && moment(this.negocio.Confirmacion.FechaEstado * 1000).hours() >= 15) ||
          this.negocio.Confirmacion.Estado === CONFIRMACION_VALUES.EN_PROCESO ||
          this.negocio.Confirmacion.Estado === CONFIRMACION_VALUES.AUTORIZADA ||
          this.negocio.Confirmacion.Estado === CONFIRMACION_VALUES.FINALIZADO;

        this.negocio.Confirmacion.showInfo = [
            CONFIRMACION_VALUES.MATCHEADA,
            CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.VENCIDA,
            CONFIRMACION_VALUES.EN_PROCESO, CONFIRMACION_VALUES.NO_AUTORIZADA,
            CONFIRMACION_VALUES.AUTORIZADA, CONFIRMACION_VALUES.FINALIZADO
          ].indexOf(this.negocio.Confirmacion.Estado) >= 0;
      }

      // Información de cuenta y números de teléfono de contactos
      this.cuentasService.getCuenta(this.negocio.Cliente.Id).take(1).subscribe(res => {
        this.cuenta = res;

        this.phoneNumbers = [];
        if (this.cuenta.Telefono) {
          this.phoneNumbers.push({
            label: 'Teléfono de la Empresa',
            phone: this.cuenta.Telefono,
            cuentaId: this.cuenta.Id
          });
        }
        if (this.cuenta.Contacts && this.cuenta.Contacts.length) {
          const index = this.cuenta.Contacts.findIndex(c => c.Principal);
          if (index < 0 || (!this.cuenta.Contacts[index].Movil && !this.cuenta.Contacts[index].Telefono)) {
            const index2 = this.cuenta.Contacts.findIndex(c => c.Movil || c.Telefono);
            if (index2 >= 0 && this.cuenta.Contacts[index2].Movil) {
              this.phoneNumbers.push({
                label: 'Móvil de un Contacto',
                phone: this.cuenta.Contacts[index2].Movil,
                clientContactId: this.cuenta.Contacts[index2].ClientContactId
              });
            }
            if (index2 >= 0 && this.cuenta.Contacts[index2].Telefono) {
              this.phoneNumbers.push({
                label: 'Teléfono de un Contacto',
                phone: this.cuenta.Contacts[index2].Telefono,
                clientContactId: this.cuenta.Contacts[index2].ClientContactId
              });
            }
          } else {
            if (this.cuenta.Contacts[index].Movil) {
              this.phoneNumbers.push({
                label: 'Móvil del Contacto Principal',
                phone: this.cuenta.Contacts[index].Movil,
                clientContactId: this.cuenta.Contacts[index].ClientContactId
              });
            }
            if (this.cuenta.Contacts[index].Telefono) {
              this.phoneNumbers.push({
                label: 'Teléfono del Contacto Principal',
                phone: this.cuenta.Contacts[index].Telefono,
                clientContactId: this.cuenta.Contacts[index].ClientContactId
              });
            }
          }
        }
        if (!this.detector['destroyed']) {
          this.detector.detectChanges();
        }
        this.spinnerService.setShowFlag(false);
      }, () => this.spinnerService.setShowFlag(false));
      this.createActivityOptions();
      if (this.activitySelected !== 'Actividad') {
        this.searchHistory();
      }
      this.editarAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.EDITAR, this.negocio.Confirmacion.Estado);
      this.anularAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.ANULAR, this.negocio.Confirmacion.Estado);
      this.duplicarAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.DUPLICAR, this.negocio.Confirmacion.Estado);
      this.cambiarTipoAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.CAMBIAR_TIPO, this.negocio.Confirmacion.Estado, this.negocio.TipoNegocio.Id);
      this.autoNoAutoAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.AUTORIZAR_NOAUTORIZAR, this.negocio.Confirmacion.Estado);
      this.autoNoAutoOlvidadoAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.AUTORIZAR_NOAUTORIZAR_OLVIDADO, this.negocio.Confirmacion.Estado);
      switch (this.negocio.TipoNegocio.Id) {
        case 6:
          this.autorizarLabel = 'Autorizar Negocio Olvidado';
          this.noAutorizarLabel = 'No Autorizar Negocio Olvidado'
          break;
        case 7:
          this.autorizarLabel = 'Autorizar Negocio de Agro'
          this.noAutorizarLabel = 'No Autorizar Negocio de Agro'
          break;
        default:
          this.autorizarLabel = 'Autorizar Negocio';
          this.noAutorizarLabel = 'No Autorizar Negocio'
      }
      this.workingFlag = false;
    }, () => {
      this.workingFlag = false;
      this.dataValid = false;
      this.spinnerService.setShowFlag(false);
    });

    this.actividadPage = 0;
    this.getNegocioActividad();
  }

  onDeleteNegocio(){
    this.dialogsService.showTextAreaDialog(
      '¿Está seguro de que desea anular este negocio?', null,
      'SÍ, ANULAR',
      'NO, CANCELAR', true)
      .take(1)
      .subscribe(res => {
        if (res) {
          this.spinnerService.setShowFlag(true);
          this.negociosService.deleteNegocio(String(this.id), res).take(1).subscribe(() => {
            this.spinnerService.setShowFlag(false);
            this.router.navigateByUrl('/' + PATH_NEGOCIOS);
          }, () => this.spinnerService.setShowFlag(false));
        }
      });
  }

  onEditNegocio() {
    this.dialogsService.showNewNegocioResponsiveDialog(false, true, this.id)
      .subscribe(value => {
        if (value) {
          this.loadData();
        }
      });
  }

  onSwapNegocioType() {
    this.dialogsService.confirm(null,
                "¿Está seguro de que quiere cambiar el tipo de este negocio?",
                "SÍ, CAMBIAR",
                "NO, CANCELAR")
      .take(1)
      .subscribe( res => {
        if (res) {
          this.spinnerService.setShowFlag(true);
          this.negociosService.swapNegocioType(this.id).take(1).subscribe(() => {
            this.loadData();
          }, () => this.spinnerService.setShowFlag(false));
        }
      });
  }

  onDuplicateNegocio() {
    this.dialogsService.showNewNegocioResponsiveDialog(true, false, this.id)
      .subscribe( (value) => {
        if (value) {
          this.router.navigateByUrl('/' + PATH_NEGOCIOS);
        }
      });
  }

  onColaboradorSelected(colaborador){
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.UserId]);
  }

  onCuentaSelected(cuenta) {
    if (this.cuenta && this.cuenta.Acopios.length) {
      window.open(`${environment.EXTERNAL_BASE_URL}/${PATH_CUENTA_DETAIL}/${this.cuenta.Acopios[0].Id}/${cuenta.Id}`, '_self');
    }
  }

  getConfirmacionClass(negocio) {
    if (!negocio.Confirmacion) {
      return '';
    }
    let name = negocio.Confirmacion.Estado.split(' ').map(w => w.toLowerCase()).slice(0,2).join('-');

    // El color para estos dos estados difieren en caso de que sea una intención o una orden
    if ((name === 'vencida' || name === 'activa') &&
        negocio.TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION) {
      name += '2';
    }

    return name;
  }

  onConfirmar() {
    if (!this.workingFlag) {
      this.workingFlag = true;
      this.dialogsService.confirm(null,
                  '¿Está seguro de que quiere confirmar este negocio?',
                  'SÍ, CONFIRMAR',
                  'NO, CANCELAR')
        .take(1)
        .subscribe( res => {
          if (res) {
            this.spinnerService.setShowFlag(true);
            this.negociosService.confirmNegocio(this.id).take(1).subscribe(() => {
              this.loadData();
            }, () => {
              this.workingFlag = false;
              this.spinnerService.setShowFlag(false);
            });
          } else {
            this.workingFlag = false;
          }
        });
    }
  }

  onAuthorize() {
    if (!this.workingFlag) {
      this.workingFlag = true;
      let label = '¿Está seguro de que quiere autorizar este negocio';
      label += this.negocio.TipoNegocio.Id === 6 ? ' olvidado?' : '?';
      this.dialogsService.confirm(null, label,
                  'SÍ, AUTORIZAR',
                  'NO, CANCELAR')
        .take(1)
        .subscribe( res => {
          if (res) {
            this.spinnerService.setShowFlag(true);
            this.negociosService.authorizeNegocio(this.id).take(1).subscribe(() => {
              this.loadData();
            }, () => {
              this.workingFlag = false;
              this.spinnerService.setShowFlag(false);
            });
          } else {
            this.workingFlag = false;
          }
        });
    }
  }

  onUnauthorize() {
    if (!this.workingFlag) {
      this.workingFlag = true;
      let label = '¿Está seguro de que no quiere autorizar este negocio';
      label += this.negocio.TipoNegocio.Id === 6 ? ' olvidado?' : '?';
      this.dialogsService.confirm(null, label,
                  'SÍ, NO AUTORIZAR',
                  'NO, CANCELAR')
        .take(1)
        .subscribe( res => {
          if (res) {
            this.spinnerService.setShowFlag(true);
            this.negociosService.unauthorizeNegocio(this.id).take(1).subscribe(() => {
              this.loadData();
            }, () => {
              this.workingFlag = false;
              this.spinnerService.setShowFlag(false);
            });
          } else {
            this.workingFlag = false;
          }
        });
    }
  }

  onConsultarMesa() {
    if (!this.workingFlag) {
      this.workingFlag = true;
      this.dialogsService.confirm(null,
                  '¿Consultar a la mesa? Esto cambiará el estado de este negocio a En Proceso de Autorización',
                  'SÍ, CONSULTAR',
                  'NO, CANCELAR')
        .take(1)
        .subscribe( res => {
          if (res) {
            this.spinnerService.setShowFlag(true);
            this.negociosService.requestAuthorization(Number(this.id)).take(1).subscribe(() => {
              this.loadData();
              this.workingFlag = false;
            }, () => {
              this.workingFlag = false;
              this.spinnerService.setShowFlag(false);
            });
          } else {
            this.workingFlag = false;
          }
        }
      );
    }
  }

  onRejectSP() {
    if (!this.workingFlag) {
      this.workingFlag = true;
      this.dialogsService.confirm(null,
                  '¿Rechazar Precio Especial? Esto cambiará el estado de este negocio a Activo',
                  'SÍ, RECHAZAR',
                  'NO, CANCELAR')
        .take(1)
        .subscribe( res => {
          if (res) {
            this.spinnerService.setShowFlag(true);
            this.negociosService.rejectSpecialPrice(Number(this.id)).take(1).subscribe(() => {
              this.loadData();
              this.workingFlag = false;
            }, () => {
              this.workingFlag = false;
              this.spinnerService.setShowFlag(false);
            });
          } else {
            this.workingFlag = false;
          }
        }
      );
    }
  }

  registerWSPCall(contacto) {
    if (contacto.clientContactId) {
      this.negociosService.registerNegociosCall(contacto.clientContactId, this.id).take(1).subscribe(() => {
        this.actividadPage = 0;
        this.getNegocioActividad();
      });
    }
  }

  ngOnDestroy() {
    this.onDestroySubject.next();
    this.negociosService.removeCurrentNegocio().take(1).subscribe();
  }

  getNegocioActividad(showSpinner = false) {
    if (showSpinner) {
      this.spinnerService.setShowFlag(true);
    }
    this.negociosService.getActividad(this.id, this.actividadPage)
      .take(1)
      .subscribe(data => {
        if (this.actividadPage) {
          this.actividad = [...this.actividad, ...data.ResponseData];
        } else {
          this.actividad = data.ResponseData;
        }
        if (showSpinner) {
          this.spinnerService.setShowFlag(false);
        }
        this.keepRetrieving = data.ResponseData.length > 0;
      }, () => {
        if (showSpinner) {
          this.spinnerService.setShowFlag(false);
        }
      });
  }

  onBottomReached() {
    if (this.keepRetrieving) {
      this.actividadPage++;
      this.getNegocioActividad(true);
    }
  }

  showAuthorizeUnauthorizeButton() {
    if (this.negocio.Confirmacion) {
      if (this.negocio.TipoNegocio.Id === 6) {
        return this.autoNoAutoOlvidadoAllowed && Number(localStorage.getItem('userId')) !== this.negocio.Responsable.UserId;
      } else if (this.negocio.TipoNegocio.Id === 7) {
        return this.negocio.Match && this.autoNoAutoAllowed && this.isBefore20;
      } else {
        return this.isBefore20 && !this.isSojaDispo && this.negocio.Match && this.autoNoAutoAllowed;
      }
    }
    return false;
  }

  onSelectActividad() {
    this.activitySelector.open();
  }

  searchHistory() {

    if (this.activitySelected === 'Cambios de Negocio') {
      this.historyLoading = true;
      this.historyList = [];
      this.historyService.getHistory(HISTORY_LIST_ENTITY.NEGOCIO, this.id)
        .take(1)
        .subscribe(x => {
          this.historyList = this.historyService.setupData(HISTORY_LIST_ENTITY.NEGOCIO, x);
          this.historyLoading = false;
        }, () => {
          this.historyLoading = false;
        });
    } else if (this.activitySelected.split(' ').length >= 3) {
      this.historyLoading = true;
      this.historyListAviso = [];
      const parts = this.activitySelected.split(' ');
      const avisoId = parts.length === 3 ? this.negocio.NegocioAvisos[0].Id : this.negocio.NegocioAvisos[Number.parseInt(parts[3], 10) - 1].Id;
      this.historyService.getHistory(HISTORY_LIST_ENTITY.AVISO, avisoId)
        .take(1)
        .subscribe(x => {
          this.historyListAviso = this.historyService.setupData(HISTORY_LIST_ENTITY.AVISO, x);
          this.historyLoading = false;
        }, () => {
          this.historyLoading = false;
        });
    }
  }

  createActivityOptions() {
    this.activityOptions = ['Actividad', 'Cambios de Negocio'];
    if (this.negocio.NegocioAvisos && this.negocio.NegocioAvisos.length) {
      if (this.negocio.NegocioAvisos.length === 1) {
        this.activityOptions.push('Cambios de Aviso');
      } else {
        this.negocio.NegocioAvisos.forEach((x, i) => {
          this.activityOptions.push('Cambios del Aviso' + ' ' + (i + 1));
        });
      }
    }
  }

  permisoAutorizado(accionId) {
    return this.permisosService.permisoAutorizado(accionId);
  }

  getFuenteName = getFuenteName
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocio-detail/negocio-detail.component.ts